import {Observable} from "rxjs";
import {AbstractRepositoryV2} from "../abstractRepositoryV2";
import {EntityAction} from "@ngrx/data";
import {AbstractDataServiceAdapter} from "../dataservice/adapter/abstractDataService.adapter";
import {IDefaultNoCacheService} from "./iDefaultNoCache.service";

export abstract class IDefaultService<StoredEntity, Entity> extends IDefaultNoCacheService<Entity> {

    readonly repository: AbstractRepositoryV2<StoredEntity>;
    readonly dataService: AbstractDataServiceAdapter<StoredEntity, Entity, any>;
    readonly entityName: string;

    readonly entityActions$: Observable<EntityAction>;


    protected constructor(repository: AbstractRepositoryV2<StoredEntity>, dataService: AbstractDataServiceAdapter<StoredEntity, any, any>) {
        super();
        this.repository = repository;
        this.dataService = dataService;
        this.entityName = repository.entityName;
        this.entityActions$ = repository.entityActions$;
    }

    getEntityId(entity: Entity): string | number {
        return this.repository.selectId(this.dataService.buildStoredEntityEntity(entity));
    }

}
